import { Assets } from './Assets'

export const MortgageLiabilities = ({ liabilities, handleOnClick }) => {
  const mortgateLiabilities = (liabilities || []).filter(
    (option) => option.subType === MortgageLiabilities.targetCategory
  )
  return (
    <Assets
      assets={mortgateLiabilities}
      handleOnClick={handleOnClick}
      category={MortgageLiabilities.targetCategory}
    />
  )
}
MortgageLiabilities.targetCategory = 'mortgage'
